import { useState, useEffect } from 'react';
import { useFormStore } from '../stores/formData';
import useAdvisorLookup from './useAdvisorLookup';

const useAgentId = () => {
  const actions = useFormStore((state) => state.actions);
  const { lookupAdvisor } = useAdvisorLookup();

  const [agentId] = useState(() => {
    const fromGon = window.gon?.agent_id ?? null;
    const fromUrl = new URLSearchParams(window.location.search).get('agent_id') ?? null;

    let fromSession = null;
    try { fromSession = sessionStorage.getItem('agent_id') ?? null; } catch (_e) { /* storage disabled */ }

    // Use first non-null, non-empty source in priority order
    const raw = [fromGon, fromUrl, fromSession].find(v => v != null && v !== '') ?? null;

    // Validate: only alphanumeric characters and hyphens to prevent XSS
    const id = (raw && /^[a-zA-Z0-9-]+$/.test(raw)) ? raw : null;

    try {
      if (id) {
        sessionStorage.setItem('agent_id', id);
      } else if (fromGon != null || fromUrl != null || fromSession != null) {
        sessionStorage.removeItem('agent_id');
      }
    } catch (_e) { /* storage disabled */ }

    return id;
  });

  // Store agentId in Zustand
  useEffect(() => {
    if (agentId) {
      actions.agent.setAgentId(agentId);
    }
  }, [agentId]);

  // Resolve advisor data from agentId
  useEffect(() => {
    if (!agentId) return;

    const fetchAdvisorData = async () => {
      try {
        const result = await lookupAdvisor(agentId);
        if (result?.found) {
          actions.agent.setAdvisorData(result);
        } else {
          actions.agent.setAdvisorData(null);
        }
      } catch (_err) {
        actions.agent.setAdvisorData(null);
      }
    };

    fetchAdvisorData();
  }, [agentId]);

  return agentId;
};

export default useAgentId;
